import "./IconLightBulb.scss";

export const IconLightBulb = () => {
  return <span className="icon-lightBulb"></span>;
};
